// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1fb39","title":"InfoRow_title__3liS8"};